export default "assets/images/slider-arrow-3d930539.svg";